import { Component } from "@angular/core";

@Component({
	selector: "app-help-note",
	templateUrl: "./help-note.component.html",
	styleUrls: ["./help-note.component.css"],
})
export class HelpNoteComponent {}
